<template>
  <div class="container">
    <a-popover placement="bottomLeft">
      <template
        #content
        class="content-container"
      >
        <performance-content v-bind="$attrs" />
      </template>
      <span class="performance">
        {{ $t('okr.list.performanceTarget') }}
      </span>
    </a-popover>
  </div>
</template>
<script>
import PerformanceContent from '../PerformanceContent.vue'
export default {
  components: { PerformanceContent }
}
</script>

<style lang="less" scoped>
.container {
  margin-top: 6px;
}
.performance {
  font-size: 12px;
  color: #64b5f6;
  &:hover {
    cursor: pointer;
  }
}
</style>
